import { graphql } from 'react-relay';
import type { FormEntry_Pagination_Query$variables } from './__generated__/FormEntry_Pagination_Query.graphql';

export * from './__generated__/FormEntry_Pagination_Fragment.graphql';

export type FormEntry_Pagination_Fragment$args = FormEntry_Pagination_Query$variables;

// #pagination #relay #useRefetchableFragment #usePaginationFragment #gold #standard #goldstandard
// This function is the gold standard for how to use the pagination fragment
// and how the query should be structured.
export const FormEntriesPaginationFragment = graphql`
  fragment FormEntry_Pagination_Fragment on RootQuery
  @argumentDefinitions(
    first: { type: "Int" }
    after: { type: "String" }
    where: { type: "RootQueryToFormEntryConnectionWhereArgs" }
  )
  @refetchable(queryName: "FormEntry_Pagination_Query") {
    formEntries(after: $after, first: $first, where: $where) @connection(key: "FormEntry_Pagination_formEntries") {
      count
      __id
      edges {
        node {
          id
          created
          modified
          formId
          form(where: { statusIn: [PUBLISH, TRASH] }) {
            node {
              title
            }
          }
          email
          firstName
          lastName
          message
          phoneNumber
          companyName
          jobTitle
          visitorId
          marketingConsent
        }
      }
    }
  }
`;

export * from './__generated__/FormEntry_Root_Query.graphql';
export const FormEntryRootQuery = graphql`
  query FormEntry_Root_Query {
     ...FormEntry_Pagination_Fragment @arguments(first: 24, after: null)
  }
`;
